import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import Tooltip from '@material-ui/core/Tooltip';
const useViewStyles = makeStyles({
  root: {},
});

const useItemStyles = makeStyles((theme) => ({
  root: {
    '& > .MuiTreeItem-content': {
      height: '35px',
    },
    '& > .MuiTreeItem-content > .MuiTreeItem-label': {
      display: 'flex',
      alignItems: 'center',
      padding: '4px 0',
      background: 'transparent !important',
      pointerEvents: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      padding: '0 15px 15px',
    },
    '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
      content: "''",
      display: 'inline-block',
      minWidth: 15,
      minHeight: 15,
      marginRight: 8,
      border: '1px solid #ccc',
      background: 'white',
    },
  },
  iconContainer: {
    marginRight: 3,
    marginLeft: 0,
    '& > svg': {
      '&:hover': {
        opacity: 0.6,
      },
    },
  },
  label: {
    padding: 0,
  },
  selected: {
    '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
      background: theme.palette.primary.main,
      // content: '\f095',
      border: '1px solid #ccc',
      // fontFamily: 'Font Awesome 5 Free',
    },
  },
  tooltipTable: {
    minWidth: ' 250px',
    maxWidth: '100%',
    padding: '30px',
    borderCollapse: ' collapse',
    background: '#ffffff',
    padding: '10px',
  },
  tooltipTable_Tr: {
    height: '25px',
    color: '#7A869A',
    fontSize: '12px',
    background: '#fff',
  },
  tooltipTable_td: {
    height: '25px',
    paddingLeft: '10px',
    color: '#7A869A',
    // background: '#f4f6fc',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    // borderLeft: '1px solid #303030',
    fontSize: '12px',
  },
  tooltipTable_th: {
    height: '25px',
    paddingLeft: '10px',
    color: 'rgb(9, 38, 130)',
    background: '#ffffff',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
}));

const ControlledTreeView = ({
  treeItems,
  expanded = [],
  selected = [],
  onNodeToggle,
  onNodeSelect,
  allSubjects = {},
}) => {
  const classesView = useViewStyles();
  const classesItem = useItemStyles();
  const [parentsClick, setParentsClick] = React.useState([]);

  const BlueOnGreenTooltip = withStyles({
    tooltip: {
      color: 'lightblue',
      border: '1px solid #fff',
      borderRadius: '4px',
      background: '#ffffff',
      boxShadow: '-2px 1px 8px 1px #737f8d',
    },
  })(Tooltip);

  const allRenderData = Object.values(allSubjects);

  const HeaderTable = (
    <tr className={classesItem.tooltipTable_Tr}>
      <th className={classesItem.tooltipTable_th}></th>
      <th className={classesItem.tooltipTable_th}>Required</th>
      <th className={classesItem.tooltipTable_th}>Allocated</th>
    </tr>
  );

  const toopTiptext = (label) =>
    allRenderData[0]?.map((e) => {
      if (e.courseName == label) {
        const childData = Object.values(e.Allocated);
        const childDataKey = Object.keys(e.Allocated);
        const childRequiredData = Object.values(e.Required);

        if (!e.Required.Total) {
          return (
            <>
              <table className={classesItem.tooltipTable}>
                {HeaderTable}
                <tr>
                  <th className={classesItem.tooltipTable_th}></th>
                  <th className={classesItem.tooltipTable_th}>
                    {'No Data Found'}
                  </th>
                  <th className={classesItem.tooltipTable_th}>{''}</th>
                </tr>
              </table>
            </>
          );
        } else {
          return (
            <>
              <table className={classesItem.tooltipTable}>
                {HeaderTable}
                {childDataKey.map((child, i) => {
                  if (childRequiredData[i]) {
                    return (
                      <tr>
                        <th className={classesItem.tooltipTable_th}>{child}</th>
                        <td className={classesItem.tooltipTable_td}>
                          {childRequiredData[i]}
                        </td>
                        <td className={classesItem.tooltipTable_td}>
                          {childData[i]}
                        </td>
                      </tr>
                    );
                  } else {
                    return '';
                  }
                })}
              </table>
            </>
          );
        }
      }
    });
  const getTreeItemsFromData = (treeItems) => {
    return treeItems.map((treeItemData) => {
      let children = undefined;
      if (treeItemData.children && treeItemData.children?.length > 0) {
        children = getTreeItemsFromData(treeItemData.children);
      }
      return (
        <TreeItem
          // classes={classesItem}
          label={treeItemData.name}
          nodeId={treeItemData.id}
          children={children}
        />
      );
    });
  };
  const StyledTreeItem = (props) => {
    if (parentsClick.includes(props.id))
      return <TreeItem nodeId={props.id} label={props.label} {...props} />;
    else
      return (
        <BlueOnGreenTooltip title={toopTiptext(props.label)} placement="left">
          <TreeItem
            classes={classesItem}
            // classes={classesItem}
            label={props.label}
            nodeId={props.id}
            children={props.children}
          />
        </BlueOnGreenTooltip>
      );
  };

  return (
    //  <BlueOnGreenTooltip title={toopTiptext} placement="left">
    <TreeView
      classes={classesView}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      expanded={expanded}
      selected={selected}
      onNodeToggle={onNodeToggle}
      onNodeSelect={onNodeSelect}
      multiSelect
    >
      {console.log('treeItems', treeItems)}
      {treeItems.length > 0 &&
        treeItems.map((item1stLvl) => (
          <StyledTreeItem
            key={item1stLvl.id}
            id={item1stLvl.id}
            label={item1stLvl.name}
            children={item1stLvl.children}
            onClick={() => {
              if (parentsClick.includes(item1stLvl.id))
                setParentsClick(() =>
                  parentsClick.filter((item) => item !== item1stLvl.id)
                );
              else setParentsClick([item1stLvl.id, ...parentsClick]);
            }}
          >
            {item1stLvl.children.length > 0 &&
              item1stLvl.children.map((item2ndLvl) => {
                return (
                  <StyledTreeItem
                    key={item2ndLvl.id}
                    id={item2ndLvl.id}
                    label={item2ndLvl.name}
                    children={item2ndLvl.children}
                  />
                );
              })}
          </StyledTreeItem>
        ))}
    </TreeView>
    //  </BlueOnGreenTooltip>
  );
};

export default ControlledTreeView;
